import { useTranslation } from "react-i18next"

import { Card } from "@/components/ui/card"
import { DocSlotCard } from "@/features/transit/components/doc-slot-card"
import { otDocSlotsForStage } from "@/features/transit/lib/doc-slots"
import type { OT, OTDocSlotId, OTStage } from "@/features/transit/api/types"

interface StageDocGridProps {
  ot: OT
  stage: OTStage
  // Optional list of slot ids to skip — used by Embarquement to render
  // the draft BL in its own custom card while still showing the rest.
  exclude?: OTDocSlotId[]
}

export function StageDocGrid({ ot, stage, exclude }: StageDocGridProps) {
  const { t } = useTranslation("transit")
  const slots = otDocSlotsForStage(ot, stage).filter(
    (s) => !exclude?.includes(s.id),
  )
  if (slots.length === 0) return null

  return (
    <Card className="flex flex-col gap-3 p-5">
      <div>
        <p className="text-muted-foreground text-[11px] font-semibold uppercase tracking-wide">
          {t("stageDocs.eyebrow")}
        </p>
        <h2 className="text-lg font-semibold tracking-tight">
          {t("stageDocs.title", { stage: t(`stages.${stage}`) })}
        </h2>
        <p className="text-muted-foreground mt-1 text-xs">
          {t("stageDocs.description")}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
        {slots.map((slot) => (
          <DocSlotCard key={slot.id} ot={ot} slotId={slot.id} />
        ))}
      </div>
    </Card>
  )
}
